import moment from "moment";

import { HvTimePickerValue } from "@hitachivantara/uikit-react-lab";

import {
  DateTimeRange,
  DateTimeStrings,
  Distance,
  NumericRange,
  QueryRuleValue,
} from "./types";

export const typeNormalizer = (type: string): string => {
  return type.replace(/\s/g, "").toLowerCase();
};

export const validateEmail = (email: string): boolean => {
  const re =
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
/**
 * Pads the unit time values so that they always have two digits
 * @param {Number} value - unit time value
 * @returns The unit time value with two digits
 */
export const padTime = (value: number | string): string => {
  if (!value || value < 0) {
    return "00";
  }
  if (value < 10 && value.toString().length === 1) {
    return `0${value.toString()}`;
  }

  return value.toString();
};

export const parseDate = (date?: string | null): Date | undefined => {
  if (date != null) {
    return moment(date).toDate();
  }

  return undefined;
};

export const parseTime = (time?: string | null): HvTimePickerValue | null => {
  if (time != null) {
    const parts = time.split(":");

    if (parts.length === 3) {
      return {
        hours: Number.parseInt(parts[0], 10),
        minutes: Number.parseInt(parts[1], 10),
        seconds: Number.parseInt(parts[2], 10),
      };
    }
  }

  return null;
};

export function isDistance(value: QueryRuleValue): value is Distance {
  return (
    (value as Distance).distance !== undefined ||
    ((value as Distance).address !== undefined &&
      (value as Distance).longitude !== undefined &&
      (value as Distance).latitude !== undefined)
  );
}

export function isNumericRange(value: QueryRuleValue): value is NumericRange {
  return (
    (value as NumericRange).from !== undefined &&
    (value as NumericRange).to !== undefined
  );
}

export function isDateTimeStrings(
  value: QueryRuleValue
): value is DateTimeStrings {
  return (
    (value as DateTimeStrings).date !== undefined &&
    (value as DateTimeStrings).time !== undefined
  );
}

export function isDateTimeRange(value: QueryRuleValue): value is DateTimeRange {
  return (
    (value as DateTimeRange).start !== undefined &&
    (value as DateTimeRange).end !== undefined
  );
}

export const validateDateTimeValues = (
  startDate: string | null | undefined,
  startTime: string | null | undefined,
  endDate?: string | null,
  endTime?: string | null
): boolean => {
  if (parseDate(startDate) == null) {
    return false;
  }
  if (parseTime(startTime) == null) {
    return false;
  }

  if (endDate !== undefined || endTime !== undefined) {
    if (parseDate(endDate) == null) {
      return false;
    }
    if (parseTime(endTime) == null) {
      return false;
    }
    const endDateIsBefore =
      startDate != null && endDate != null && endDate < startDate;

    const endTimeIsBeforeOrSame =
      startDate != null &&
      endDate != null &&
      endDate === startDate &&
      startTime != null &&
      endTime != null &&
      endTime <= startTime;

    const endDateTimeIsBefore = endDateIsBefore || endTimeIsBeforeOrSame;

    return !endDateTimeIsBefore;
  }

  return true;
};
